<template>
  <div class="card locker-card">
    <!-- <card-image :imageURL="locker.lockerInfo.imageURL" /> -->

    <div class="card-content">
      <locker-title :name="locker.lockerInfo.name" />

      <locker-stats :locker="locker" />

      <div
        class="has-text-centered configs-div"
        v-if="permissions.makeDelivery"
      >
        <button
          class="button"
          :style="{
            backgroundColor: $primaryColor,
            color: $primaryColorContrast
          }"
          @click="deliver"
        >
          <b-icon
            icon="motorcycle"
            v-if="locker.lockerInfo.hasCourier"
          ></b-icon>
          <b-icon icon="hand-paper" v-else></b-icon>
          &nbsp;&nbsp;&nbsp;&nbsp;{{ $t("dashboard.deliver") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
// import cardImage from "./locker-card/CardImage";
import lockerTitle from "./locker-card/LockerTitle";
import lockerStats from "./locker-card/LockerStats";

export default {
  props: ["locker"],

  mixins: [common],

  components: {
    // cardImage,
    lockerTitle,
    lockerStats
  },

  methods: {
    deliver() {
      this.$emit("open-delivery-modal", this.locker);
    }
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>

<style scoped>
.locker-card {
  margin-bottom: 2rem;
}
.card-content {
  padding: 0.7rem;
  padding-bottom: 1rem;
}
.configs-div {
  margin-top: 1.5rem;
}
</style>
